/**
 * Split Kanban Board
 * Supports both 7-day weekly view and dynamic cycle mode (up to 8 days)
 */

import { Plus } from 'lucide-react'
import { DAYS_OF_WEEK } from '../../lib/constants'
import { useSplitConfigStore } from '../../stores/splitConfigStore'
import { DayColumn } from './DayColumn'
import { CycleDayColumn } from './CycleDayColumn'

export const SplitKanbanBoard = () => {
  const { cycleMode, cycleAssignments, addCycleDay } = useSplitConfigStore()
  
  if (cycleMode) {
    return (
      <div className="w-full">
        {/* Horizontal scrollable container */}
        <div className="overflow-x-auto pb-4">
          <div className="flex min-w-full gap-2">
            {cycleAssignments.map((_, index) => (
              <CycleDayColumn key={`day-${index}`} dayIndex={index} />
            ))}
            
            {/* Add day button */}
            {cycleAssignments.length < 8 && (
              <div className="flex min-w-76 flex-col">
                {/* Placeholder for day header to match alignment */}
                <div className="h-6 mb-2" />
                
                {/* Add day card - matches empty slot structure */}
                <div
                  onClick={addCycleDay}
                  className="flex min-h-96 cursor-pointer items-center justify-center rounded-lg border-2 border-dashed border-muted-foreground/30 hover:border-muted-foreground/50 hover:bg-muted/20 bg-transparent p-4"
                >
                  <div className="text-muted-foreground flex flex-col items-center gap-2">
                    <Plus className="h-6 w-6" />
                    <span className="text-sm">Add Day</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
  
  // Normal mode - show fixed 7 days
  return (
    <div className="w-full">
      {/* Horizontal scrollable container */}
      <div className="overflow-x-auto pb-4">
        <div className="flex min-w-full gap-2">
          {DAYS_OF_WEEK.map((day) => (
            <DayColumn key={day} day={day} />
          ))}
        </div>
      </div>
    </div>
  )
}
